module.exports = __webpack_public_path__ + "static/media/Error_RedBubble.53120d43.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/rlgl/Intro/svg/Error_RedBubble.svg
// module id = 428
// module chunks = 0